import { IRect } from 'konva/lib/types';
import { Circle, Rect } from 'react-konva';
import { ImgProps } from '../types';

export const DebuggingImageData = ({
  bBox, clipCenter, clipOrigin, faceplateBbox
}: {
  bBox: IRect;
} & Pick<ImgProps, 'clipCenter' | 'clipOrigin' | 'faceplateBbox'>) => (bBox ? (
  <>
    <Circle
      fill="rgb(255, 255, 0)"
      radius={15}
      x={clipCenter[0]}
      y={clipCenter[1]} />
    <Rect
      stroke="rgb(0, 255, 0)"
      strokeWidth={4}
      x={bBox.x}
      y={bBox.y}
      width={bBox.width}
      height={bBox.height} />
    <Circle
      fill="rgb(255, 0, 0)"
      radius={10}
      x={bBox.x + bBox.width / 2}
      y={bBox.y + bBox.height / 2} />
    <Circle
      fill="rgb(255, 0, 0)"
      radius={10}
      x={bBox.x}
      y={bBox.y} />
    <Circle
      fill="rgb(255, 0, 0)"
      radius={10}
      x={bBox.x + bBox.width}
      y={bBox.y} />
    <Circle
      fill="rgb(255, 0, 0)"
      radius={10}
      x={bBox.x + bBox.width}
      y={bBox.y + bBox.height} />
    <Circle
      fill="rgb(255, 0, 0)"
      radius={10}
      x={bBox.x}
      y={bBox.y + bBox.height} />
    {faceplateBbox && (
      <Rect
        stroke="rgb(0, 0, 255)"
        strokeWidth={4}
        x={faceplateBbox.left + (clipOrigin ? clipOrigin[0] : 0)}
        y={faceplateBbox.top + (clipOrigin ? clipOrigin[1] : 0)}
        width={faceplateBbox.right - faceplateBbox.left}
        height={faceplateBbox.bottom - faceplateBbox.top} />
    )}
  </>
) : null);
